//  Copyright (c) 2026 Molly Xue
//  Licensed under the MIT License

import { loadVideo } from './loadVideo/webCam.js';
import { handleScrollByGesture } from './handleGestureInteraction/handleScrollByHandGesture.js';
import { mapToScreen } from './handleGestureInteraction/cursorController.js';
import { detectFistToOpenPalmClickGesture } from './handleGestureInteraction/clickByHandGesture.js';
import { detectModalGestures } from './handleGestureInteraction/gestureForImageModal.js';

const indexCursor = document.getElementById('virtual-cursor');

// ── Device-aware video config ─────────────────────────────
function getVideoConfig() {
  const isLowEnd = navigator.hardwareConcurrency <= 4;
  const isMobile = window.innerWidth < 768;

  return {
    width: isMobile ? Math.min(window.innerWidth, 640) : window.innerWidth,
    height: isMobile ? Math.min(window.innerHeight, 480) : window.innerHeight,
    fps: isLowEnd || isMobile ? 20 : 30,
  };
}

async function startDetectionLoop(model, video, videoWidth, videoHeight) {
  async function runDetection() {
    // Draw hand landmarks
    const predictions = await model.estimateHands(video);

    if (predictions !== null && predictions.length > 0) {
      let prediction = predictions[0];

      const indexFingerTipX = prediction.annotations.indexFinger[3][0];
      const indexFingerTipY = prediction.annotations.indexFinger[3][1];

      const thumbX = prediction.annotations.thumb[3][0];
      const thumbY = prediction.annotations.thumb[3][1];

      const pinchDist = Math.hypot(indexFingerTipX - thumbX, indexFingerTipY - thumbY);

      const treshold = 40;
      let pinch = pinchDist <= treshold;

      // ── Scroll ───────────────────────────────────────────
      handleScrollByGesture(pinch, predictions);

      // ── Cursor ───────────────────────────────────────────
      indexCursor.style.display = 'none';

      const { screenX, screenY } = mapToScreen(
        indexFingerTipX,
        indexFingerTipY,
        videoWidth,
        videoHeight,
      );
      indexCursor.style.display = 'block';

      // ── Click gesture (five-finger cluster → open palm) ──
      detectFistToOpenPalmClickGesture(prediction);

      // ── Modal gesture (pinch-hold) + image hover overlay ─
      if (screenX && screenY && !isNaN(screenX) && !isNaN(screenY)) {
        detectModalGestures(prediction, screenX, screenY);
      }
    }

    requestAnimationFrame(runDetection);
  }

  //model = await handpose.load();
  runDetection();
}

// ── Bootstrap ─────────────────────────────────────────────
async function main() {
  const cfg = getVideoConfig();
  const video = await loadVideo(cfg.width, cfg.height, cfg.fps);

  // Dimensions are definitely available here
  const videoWidth = video.videoWidth;
  const videoHeight = video.videoHeight;

  // Load model AFTER video is ready, then kick off the loop
  const model = await handpose.load();

  startDetectionLoop(model, video, videoWidth, videoHeight);
}

main();
